// 안전한 캐싱 유틸리티

export class CacheUtil {
  private static readonly CACHE_PREFIX = 'meet_mall_';
  private static readonly DEFAULT_TTL = 5 * 60 * 1000; // 5분

  static setItem(key: string, value: any, ttl: number = this.DEFAULT_TTL): boolean {
    try {
      const cacheKey = this.CACHE_PREFIX + key;
      const cacheData = {
        value,
        timestamp: Date.now(),
        ttl,
      };
      localStorage.setItem(cacheKey, JSON.stringify(cacheData));
      return true;
    } catch (error) {
      console.warn('캐시 저장 실패:', error);
      return false;
    }
  }

  static getItem<T>(key: string): T | null {
    try {
      const cacheKey = this.CACHE_PREFIX + key;
      const cached = localStorage.getItem(cacheKey);
      
      if (!cached) {
        return null;
      }

      const cacheData = JSON.parse(cached);
      const now = Date.now();
      
      // TTL 확인
      if (now - cacheData.timestamp > cacheData.ttl) {
        this.removeItem(key);
        return null;
      }

      return cacheData.value;
    } catch (error) {
      console.warn('캐시 읽기 실패:', error);
      this.removeItem(key);
      return null;
    }
  }

  static removeItem(key: string): boolean {
    try {
      const cacheKey = this.CACHE_PREFIX + key;
      localStorage.removeItem(cacheKey);
      return true;
    } catch (error) {
      console.warn('캐시 삭제 실패:', error);
      return false;
    }
  }

  static clear(): boolean {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(this.CACHE_PREFIX)) {
          localStorage.removeItem(key);
        }
      });
      return true;
    } catch (error) {
      console.warn('캐시 전체 삭제 실패:', error);
      return false;
    }
  }

  static isExpired(key: string): boolean {
    try {
      const cacheKey = this.CACHE_PREFIX + key;
      const cached = localStorage.getItem(cacheKey);
      
      if (!cached) {
        return true;
      }

      const cacheData = JSON.parse(cached);
      const now = Date.now();
      
      return now - cacheData.timestamp > cacheData.ttl;
    } catch (error) {
      return true;
    }
  }
}
